module.exports = __webpack_public_path__ + "img/8.4131e326.jpg";